import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import { isFeeConcept } from '@/returns/helpers/helpers'

import RefundConceptToggle from './RefundConceptToggle/RefundConceptToggle'
import * as Styles from './styles'

const RefundConcepts = ({
  concepts,
  currency,
  onClickInConcept,
  onChangeConceptAmount,
  onChangeItemAmount,
  editable,
  lineItems,
  newItems,
}) => {
  const { t } = useTranslation()

  const amountsToReturn = concepts?.filter(concept => !isFeeConcept(concept))
  const fees = concepts?.filter(isFeeConcept)

  return (
    <Styles.RefundContainer>
      {amountsToReturn?.length > 0 && (
        <>
          <Text type="titleS">{t('Conceptos a reembolsar')}</Text>
          <Text type="bodyMRegular">{t('Selecciona los conceptos que quieres reembolsar')}:</Text>
          <Styles.ConceptsContainer>
            {amountsToReturn.map(concept => (
              <RefundConceptToggle
                key={concept.id}
                concept={concept}
                currency={currency}
                editable={editable}
                lineItems={lineItems}
                newItems={newItems}
                onClickInConcept={onClickInConcept}
                onChangeConceptAmount={onChangeConceptAmount}
                onChangeItemAmount={onChangeItemAmount}
              />
            ))}
          </Styles.ConceptsContainer>
        </>
      )}
      {fees?.length > 0 && (
        <>
          <Text type="titleS">{t('Fees')}</Text>
          <Text type="bodyMRegular">{t('Selecciona las fees a restar del total')}:</Text>
          <Styles.ConceptsContainer>
            {fees.map(concept => (
              <RefundConceptToggle
                key={concept.id}
                concept={concept}
                currency={currency}
                editable={editable}
                lineItems={lineItems}
                newItems={newItems}
                onClickInConcept={onClickInConcept}
                onChangeConceptAmount={onChangeConceptAmount}
                onChangeItemAmount={onChangeItemAmount}
              />
            ))}
          </Styles.ConceptsContainer>
        </>
      )}
    </Styles.RefundContainer>
  )
}

export default RefundConcepts
